import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/shared/link';
import styles from './styles.module.scss';

const Card = ({ link, title, imageNode, imageHeight = undefined }) => {
  const imageBoxStyle = imageHeight !== undefined ? { height: imageHeight } : undefined;

  return (
    <Link className={styles.card} to={link} suppressHydrationWarning>
      <div className={styles.imageInner} style={imageBoxStyle}>
        {imageNode}
      </div>

      {title && (
        <div className={styles.titleWrap}>
          <h3 className={styles.cardTitle}>{title}</h3>
        </div>
      )}
    </Link>
  );
};

Card.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string,
  imageNode: PropTypes.node,
  imageHeight: PropTypes.number,
};

export default Card;
